<template>
  <div class="extension-container">
    <!-- 悬浮头部 -->
    <div class="sticky-header">
      <header class="header">
        <p class="header-title">My Extension</p>
        <button class="header-button" @click="goRepaymentPage">
          Full Payment
        </button>
      </header>

      <!-- 悬浮状态卡片 -->
      <div
        class="card status-card"
        style="margin-top: 20px"
        v-if="extensionInfo.extensionBoolean"
      >
        <div class="status-indicator">
          <span class="days-count">{{ extensionInfo.period }}</span>
          <span class="days-label">Extension days</span>
        </div>

        <div class="status-details">
          <div class="detail-item">
            <span class="detail-value"
              >${{ extensionInfo.extensionAccrStr }}</span
            >
            <span class="detail-label">Extension cost</span>
          </div>
          <div class="detail-item">
            <span class="detail-value">{{
              formatDate(extensionInfo.extensionDueDateStr)
            }}</span>
            <span class="detail-label">New due date</span>
          </div>
        </div>
      </div>
    </div>

    <main class="content">
      <!-- 内容区域 -->
      <!-- 延期详情卡片 -->
      <div class="card info-card" v-if="extensionInfo.extensionBoolean">
        <div class="info-row">
          <span>Account holder:</span>
          <span>{{ extensionInfo.titular }}</span>
        </div>

        <!-- Extension Payment Button -->
        <div style="margin-top: 20px; text-align: center;">
          <button
            class="primary-btn"
            @click="copyCLABE"
            style="width: 100%; max-width: 320px;"
          >
            Extension Payment →
          </button>
        </div>
      </div>

      <!-- 无法延期提示 -->
      <div
        class="card info-card"
        style="margin-top: 20px"
        v-if="!extensionInfo.extensionBoolean"
      >
        <p class="no-extension-text">
          You cannot request an extension temporarily
        </p>
      </div>

      <!-- Safe Repayment Reminder -->
      <div
        class="card warning-card"
        v-if="extensionInfo.extensionBoolean"
      >
        <div style="display: flex; align-items: flex-start;">
          <span class="warning-icon">⚠️</span>
          <div>
            <p class="warning-title">
              Safe Repayment Reminder
            </p>
            <p class="warning-desc">
              Always repay using the UPIID shown in this App.
            </p>
            <p class="warning-desc" style="margin-bottom: 0;">
              Do NOT trust any UPIID shared in WhatsApp or personal messages.
            </p>
          </div>
        </div>
      </div>

      <!-- UTR Input Section -->
      <div
        class="card utr-card"
        v-if="extensionInfo.extensionBoolean"
      >
        <div class="utr-input-container">
          <label class="utr-label">Enter UTR Number</label>
          <p class="utr-desc">
            After completing payment, please enter your 12-digit UTR(UPI Ref.
            No.) below ↓
          </p>
          <div class="input-wrapper">
            <input
              v-model="utr"
              class="utr-input"
              type="text"
              placeholder="Enter 12-digit UTR number"
              maxlength="12"
            />
            <button class="paste-btn" @click="pasteUTR">Paste</button>
          </div>
          <div class="error-message" v-if="utr && !isValidUTR()">
            Please enter a valid 12-digit UTR number
          </div>

          <!-- Success message - only shown after successful submission -->
          <div class="success-message" v-if="utrSubmitted && utrSuccessMessage">
            {{ utrSuccessMessage }}
          </div>

          <button
            class="submit-utr-btn"
            @click="submitUTR"
            :disabled="!isValidUTR()"
          >
            Submit UTR →
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import CallApp from "callapp-lib";

export default {
  name: "ExtensionPage",
  data() {
    return {
      extensionInfo: {},
      bankMethods: {},
      repaymentCode: null,
      key: "",
      currentDate: "",
      expandedCategories: {},
      lastExpandedCategory: null,
      utr: "",
      utrSubmitted: false,
      utrSuccessMessage: "",
    };
  },
  mounted() {
    document.title = "My Extension";
  },
  created() {
    this.setCurrentDate();
    this.getDetailInfo();
  },
  methods: {
    formatDate(dateStr) {
      return dateStr ? dateStr.substr(0, 10) : "";
    },
    setCurrentDate() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, "0");
      const d = String(now.getDate()).padStart(2, "0");
      this.currentDate = `${y}-${m}-${d}`;
    },
    async getDetailInfo() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      let res = await this.$Http.getExtensionInfo(
        {
          key: keyStr,
        },
        true,
      );
      this.extensionInfo = res;

      try {
        let bankRes = await this.$Http.repaymentMethod({ key: keyStr });
        this.bankMethods = {
          "Payment Methods": Object.keys(bankRes).map((key) => ({
            repayCode: key,
            repayMethodName: key,
            selected: bankRes[key],
          })),
        };
        Object.keys(bankRes).map((key) => {
          if (bankRes[key]) {
            this.repaymentCode = key;
          }
        });
        this.initExpandedState();
      } catch (error) {
        console.error("Error fetching bank methods:", error);
      }
    },
    initExpandedState() {
      const categories = Object.keys(this.bankMethods);
      let selectedCategory = null;

      selectedCategory = categories[0];

      categories.forEach((category) => {
        const methods = this.bankMethods[category];
        const hasSelected = methods.some((method) => method.selected);
        if (hasSelected) {
          selectedCategory = category;
        }
      });

      categories.forEach((category) => {
        this.$set(this.expandedCategories, category, false);
      });

      if (selectedCategory) {
        this.$set(this.expandedCategories, selectedCategory, true);
        this.lastExpandedCategory = selectedCategory;
      } else if (categories.length > 0) {
        this.$set(this.expandedCategories, categories[0], true);
        this.lastExpandedCategory = categories[0];
      }
    },
    toggleCategory(category) {
      if (this.expandedCategories[category]) {
        this.$set(this.expandedCategories, category, false);
        this.lastExpandedCategory = null;
      } else {
        if (this.lastExpandedCategory) {
          this.$set(this.expandedCategories, this.lastExpandedCategory, false);
        }
        this.$set(this.expandedCategories, category, true);
        this.lastExpandedCategory = category;
      }
    },
    selectMethod(method) {
      Object.keys(this.bankMethods).forEach((category) => {
        this.bankMethods[category].forEach((m) => {
          this.$set(m, "selected", false);
        });
      });

      this.$set(method, "selected", true);
      this.repaymentCode = method.repayCode;
      const bankName = method.repayMethodName.includes("-")
        ? method.repayMethodName.split("-")[0]
        : method.repayMethodName;
      this.extensionInfo.repaymentBankName = bankName;
    },
    goRepaymentPage() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      this.$router.push({ path: "/repayment", query: { key: keyStr } });
    },
    getParamQueryString(url, name) {
      let subStr = name + "=";
      if (url.indexOf(subStr) !== -1) {
        let arr = url.split(subStr);
        let sub1 = arr[1];
        if (sub1.indexOf("&") !== -1) {
          let arr2 = sub1.split("&");
          return arr2[0];
        }
        return sub1;
      }
      return "";
    },
    async copyCLABE() {
      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let responseInfo = await this.$Http.repaymentUrl(
          {
            key: keyStr,
            repayCode: this.repaymentCode,
            extension: true,
          },
          false,
        );

        if (responseInfo && responseInfo.length > 0) {
          window.open(responseInfo, "_blank");
        }

        await this.$Http.pointH5Report(
          {
            key: keyStr,
            eventName: "click_pay_button",
          },
          true,
        );
      } catch (error) {
        console.error("Error:", error);
      }
    },
    isValidUTR() {
      return /^\d{12}$/.test(this.utr);
    },
    async pasteUTR() {
      try {
        const text = await navigator.clipboard.readText();
        if (/^\d{12}$/.test(text)) {
          this.utr = text;
        } else {
          this.utr = text;
        }
      } catch (err) {
        console.error("Failed to read clipboard contents: ", err);
      }
    },
    async submitUTR() {
      if (!this.isValidUTR()) {
        return;
      }

      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let response = await this.$Http.submitUrl(
          {
            key: keyStr,
            utr: this.utr,
            isExtend: true,
          },
          true,
        );

        console.log("UTR submitted successfully", response);

        if (this.$toast) {
          this.$toast.success("Success");
        } else {
          alert("Success");
        }

        this.utrSubmitted = true;
        this.utrSuccessMessage =
          response.message || "UTR submitted successfully!";
      } catch (error) {
        console.error("Error submitting UTR:", error);
        this.utrSubmitted = false;
        this.utrSuccessMessage = "";

        if (this.$toast) {
          this.$toast.fail("Failed to submit UTR");
        }
      }
    },
  },
};
</script>

<style scoped>
/* 基础容器：透明（继承全局极光背景） */
.extension-container {
  min-height: 100vh;
  background-color: transparent;
  color: #FFFFFF;
  padding-bottom: 40px;
}

/* 悬浮头部区域 */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: transparent;
}

/* 头部样式：深翡翠科技渐变 Header */
.header {
  background: linear-gradient(180deg, rgba(3, 29, 25, 0.95) 0%, rgba(1, 18, 15, 0.92) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  color: #FFFFFF;
  padding: 18px 20px 48px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 0 24px 24px;
  border-bottom: 1px solid rgba(0, 229, 163, 0.25);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5), 0 0 20px rgba(0, 229, 163, 0.08);
}

.header-title {
  font-size: 20px;
  font-weight: 800;
  flex: 1;
  text-align: left;
  letter-spacing: 0.2px;
  margin: 0;
  color: #FFFFFF;
}

.header-button {
  background: rgba(0, 229, 163, 0.12);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1.5px solid #00E5A3;
  color: #00E5A3;
  font-size: 13px;
  font-weight: 700;
  padding: 7px 16px;
  border-radius: 20px;
  cursor: pointer;
  letter-spacing: 0.5px;
  box-shadow: 0 0 10px rgba(0, 229, 163, 0.25);
  transition: all 0.2s ease;
}

.header-button:active {
  transform: scale(0.95);
  background: rgba(0, 229, 163, 0.25);
  box-shadow: 0 0 16px rgba(0, 229, 163, 0.45);
}

/* 卡片通用样式：暗青色磨砂玻璃拟态 + 边缘微光 */
.card {
  background: rgba(6, 32, 28, 0.78);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 20px;
  max-width: 600px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.5), 0 0 16px rgba(0, 229, 163, 0.06);
  border: 1px solid rgba(0, 229, 163, 0.2);
  margin: 0 16px 16px;
  flex-direction: column;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

/* 状态卡片 */
.status-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
  background: rgba(7, 36, 31, 0.88);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  color: #FFFFFF;
  margin-top: -36px;
  position: relative;
  z-index: 10;
  border: 1px solid rgba(0, 229, 163, 0.3);
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.6), 0 0 25px rgba(0, 229, 163, 0.12);
}

.status-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 16px 0 4px;
  border-right: 1px solid rgba(0, 229, 163, 0.15);
  min-width: 105px;
}

.days-count {
  font-size: 32px;
  font-weight: 800;
  line-height: 1;
  color: #00E5A3;
  letter-spacing: -0.5px;
  text-shadow: 0 0 12px rgba(0, 229, 163, 0.5);
}

.days-label {
  font-size: 12px;
  margin-top: 6px;
  color: #8CAAA6;
  font-weight: 600;
}

.status-details {
  flex: 1;
  display: flex;
  justify-content: space-around;
}

.detail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detail-value {
  font-size: 18px;
  font-weight: 800;
  color: #FFFFFF;
  margin-bottom: 4px;
}

.detail-label {
  font-size: 12px;
  color: #8CAAA6;
  font-weight: 500;
}

/* 内容区域 */
.content {
  margin: 0 auto;
  padding-bottom: 120px;
  max-width: 600px;
}

/* 信息卡片 */
.info-card {
  padding: 20px;
  margin: 16px 16px 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background-color: rgba(2, 20, 18, 0.65);
  border-radius: 14px;
  margin-bottom: 10px;
  border: 1px solid rgba(0, 229, 163, 0.12);
  font-size: 14px;
  color: #8CAAA6;
  font-weight: 500;
}

.info-row span:last-child {
  font-weight: 700;
  color: #FFFFFF;
}

.no-extension-text {
  text-align: center;
  padding: 24px 16px;
  color: #FF5353;
  font-weight: 600;
  font-size: 15px;
}

/* Warning Card */
.warning-card {
  padding: 18px 20px;
  margin: 16px 16px 16px;
  background: rgba(8, 36, 32, 0.75) !important;
  border: 1px solid rgba(0, 229, 163, 0.3) !important;
  border-radius: 16px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;
}

.warning-icon {
  font-size: 18px;
  color: #00E5A3;
  margin-right: 10px;
}

.warning-title {
  font-weight: 700;
  margin: 0 0 6px 0;
  color: #00E5A3;
  font-size: 15px;
}

.warning-desc {
  margin: 0 0 4px 0;
  font-size: 13px;
  color: #8CAAA6;
  line-height: 1.4;
}

/* UTR Input Styles */
.utr-card {
  padding: 20px;
  margin: 0 16px 20px;
}

.utr-label {
  display: block;
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 6px;
  color: #FFFFFF;
}

.utr-desc {
  font-size: 13px;
  color: #8CAAA6;
  margin: 0 0 14px 0;
  line-height: 1.4;
}

.input-wrapper {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}

.utr-input {
  flex: 1;
  padding: 12px 16px;
  background-color: rgba(2, 18, 16, 0.75);
  border: 1px solid rgba(0, 229, 163, 0.22);
  border-radius: 14px;
  font-size: 15px;
  outline: none;
  color: #FFFFFF;
  font-weight: 600;
  transition: all 0.2s;
}

.utr-input:focus {
  border-color: #00E5A3;
  background-color: rgba(3, 24, 21, 0.9);
  box-shadow: 0 0 0 3px rgba(0, 229, 163, 0.25), 0 0 15px rgba(0, 229, 163, 0.2);
}

.utr-input::placeholder {
  color: #51706B;
  font-weight: normal;
}

.paste-btn {
  background-color: rgba(0, 229, 163, 0.15);
  border: 1px solid rgba(0, 229, 163, 0.35);
  border-radius: 12px;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 700;
  color: #00E5A3;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 0 10px rgba(0, 229, 163, 0.15);
}

.paste-btn:active {
  transform: scale(0.95);
  background-color: rgba(0, 229, 163, 0.3);
}

.error-message {
  color: #FF5353;
  font-size: 13px;
  margin-bottom: 12px;
  font-weight: 600;
}

.success-message {
  color: #00E5A3;
  font-size: 13px;
  margin-bottom: 12px;
  font-weight: 600;
  text-shadow: 0 0 8px rgba(0, 229, 163, 0.4);
}

/* 主行动大按钮：参考图 START 风格 */
.primary-btn,
.submit-utr-btn {
  position: relative;
  width: 100%;
  background: linear-gradient(180deg, #04332c 0%, #011d19 100%);
  color: #FFFFFF;
  border: 1.5px solid #00E5A3;
  border-radius: 16px;
  padding: 15px;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 0 18px rgba(0, 229, 163, 0.35), 0 8px 24px rgba(0, 0, 0, 0.45), inset 0 0 12px rgba(0, 229, 163, 0.15);
  letter-spacing: 1px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.primary-btn::before,
.submit-utr-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 40%;
  background: linear-gradient(180deg, rgba(0, 229, 163, 0.15) 0%, transparent 100%);
  border-radius: 14px 14px 0 0;
  pointer-events: none;
}

.primary-btn:hover,
.submit-utr-btn:hover:not(:disabled) {
  border-color: #00F29D;
  box-shadow: 0 0 24px rgba(0, 229, 163, 0.55), 0 8px 24px rgba(0, 0, 0, 0.5), inset 0 0 16px rgba(0, 229, 163, 0.25);
  transform: translateY(-1px);
}

.primary-btn:active,
.submit-utr-btn:active:not(:disabled) {
  transform: scale(0.98);
  opacity: 0.94;
  box-shadow: 0 0 12px rgba(0, 229, 163, 0.3);
}

.submit-utr-btn:disabled {
  background: rgba(4, 30, 28, 0.5);
  border-color: rgba(0, 229, 163, 0.15);
  color: #51706B;
  box-shadow: none;
  cursor: not-allowed;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .status-card {
    flex-direction: row;
  }
}
</style>
